import $ from 'jquery';

class mainMap {
    constructor(omap){ 
        this.mymap = L.map('main-mapdiv');
        this.panoramalayer;
        this.otherpanoramalayer;
        this.markers = L.markerClusterGroup();
        this.apiKey = "AAPK49b05e7fadcd480aa78a5cb9a5467a22XvNkEA6FrMcLf78m37J8dJ3KDz98I3_K4qOVoY65V7ucDix3kmF4uZ2tB1D0PonS";
        this.events();    
    }
    events(){
        this.mymap.setView([35.2190, 24.85], 7);
        var backgroundLayer = L.tileLayer('https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}', {     
            maxNativeZoom:20,
            maxZoom:20
        });
        this.mymap.addLayer(backgroundLayer);
        this.mymap.once('focus', function() { this.mymap.scrollWheelZoom.enable(); });
        this.refreshPanoramas(this.mymap, this.markers);
        this.refreshOtherPanoramas(this.mymap, this.markers);
    }    
    refreshPanoramas(map, markers){     
        var theid=$("#theid").val();
        if (theid>0) {
            var theurl = 'https://places.panotours.gr/wp-json/geo/v1/panoramas/?theid=' + $("#theid").val(); 
            var zoomlvl=10;
        } else {
            var theurl = 'https://places.panotours.gr/wp-json/geo/v1/panoramas'; 
            var zoomlvl=0;
        }
        $.ajax({
            url: theurl, 
            type:'GET',
            data:{filter:$("#theid").val()},
            success:function(response){
                if (this.panoramalayer) {
                    this.mymap.removeLayer(this.panoramalayer);
                    $("#PanoramasZoomButtons").html("");
                };
                this.panoramalayer=L.geoJSON(response, {pointToLayer: function(feature, latlng) {
                    
                    var strButton = "<button id='zoomTo"+feature.properties.id + "'";				
                    strButton += "' class='form-control btn btn-primary attraction'>";
                    strButton += feature.properties.panorama_name+"</button>";
                    $("#PanoramasZoomButtons").append(strButton);
                    
                    $("#zoomTo"+feature.properties.id).click(function(){
                        theid=parseInt(event.currentTarget.id.replace( /^\D+/g, ''));					
                        this.mymap.setView([latlng.lat, latlng.lng], 13);
                        this.panoramalayer.eachLayer(function(layer) {
                            if(layer.options && layer.options.pane === "markerPane") {
                                if (layer.feature.properties.id === theid) {
                                    layer.fire('click');
                                }							
                            }
                        });
                        $("#selected-latdd").text(latlng.lat);
                        $("#selected-londd").text(latlng.lng);
                        // remove the circle from the group layer
                        layerGroup.clearLayers();
                        // add a circle to indicate the focused point 
                        var pointmarker = L.circle([latlng.lat, latlng.lng], {
                            color: '#1a8e9a',
                            fillColor: '#1a8e9a',
                            fillOpacity: 0.4,
                            radius: 135
                        }).addTo(layerGroup);                        
                    });
                    $("#zoomTo"+feature.properties.id).mouseover(function(){					
                        // remove the circle from the group layer
                        layerGroupMouseOver.clearLayers();					
                        var CustomIcon = L.Icon.extend({
                            options: {
                            iconSize:     [28, 28],					   
                            iconAnchor:   [14, 13],					   
                            popupAnchor:  [0, -18]
                            }
                        });
                        var panoramaIcon = new CustomIcon({
                            iconUrl: 'https://places.panotours.gr/wp-content/uploads/2023/07/Icon.png'
                        })										
                        // add a way to indicate the focused point 
                        var mouseoverpointmarker = L.marker([latlng.lat, latlng.lng], {icon: panoramaIcon}).addTo(layerGroupMouseOver);	
                    });				
                    var CustomIcon = L.Icon.extend({
                        options: {
                        iconSize:     [42, 42],					   
                        iconAnchor:   [32, 0],					   
                        popupAnchor:  [-10, -12]
                        }
                    });
                    if (+feature.properties.id==1316) {
                        var panoramaIcon = new CustomIcon({                        
                            iconUrl: 'https://places.panotours.gr/wp-content/uploads/2023/07/Icon.png'
                        })
                    } else {
                        var panoramaIcon = new CustomIcon({                        
                            iconUrl: 'https://places.panotours.gr/wp-content/uploads/2023/07/Icon.png'
                        })
                    }

                    //var strPopup = "<img title='Open in TOTT website' class='open-vtour' src='img/vtour.png' />";
                    var strPopup = "";
                    var thelink = feature.properties.website_url;
                    var tourlink = feature.properties.portfolio_link;

                    strPopup += "<h4><a title='Go to website' href='"+thelink+"' target='_parent'>"+feature.properties.title+"</a></h4><hr>";                   
                   var gfg = window.frameElement;
     
                    // Checking if webpage is embedded
                   // if (gfg) {                        
                    if (window.location !== window.parent.location) {
                        // The page is in an iFrame
                        
                        console.log("The page is in an iFrame");
                        strPopup += "<a title='Switch to " + feature.properties.title + " panorama' href='#' onclick=\"parent.postMessage('"+feature.properties.title+"','*');\"'><img src='"+feature.properties.image_path+"' style='width: 260px; box-shadow: #2e2e2e 0px 2px 5px; border: 6px solid white; border-radius: 8px; margin-top: 1px;'></a>";					
                    }
                    else {                        
                        // The page is not in an iFrame
                        console.log("The page is not in an iFrame");
                        strPopup += "<a title='Go to virtual tour " + feature.properties.title + " panorama' href='" + tourlink + "'><img src='"+feature.properties.image_path+"' style='width: 260px; box-shadow: #2e2e2e 0px 2px 5px; border: 6px solid white; border-radius: 8px; margin-top: 1px;'></a>";					
                    }
                    
                    //strPopup += "<a onclick=\"GoToPanorama('"+feature.properties.title+"')\" href='#'><img src='panorama-thumbs/"+feature.properties.image_path+"' style='width: 260px; box-shadow: #2e2e2e 0px 2px 5px; border: 6px solid white; border-radius: 8px; margin-top: 1px;'></a>";                               
                    var PopupClass = {
                        'className': 'panorama-popup'
                    }    
                    return markers.addLayer(L.marker(latlng, {icon: panoramaIcon}).bindPopup(strPopup, PopupClass));
                }});


                markers.addTo(map);
                map.fitBounds(this.panoramalayer.getBounds());
                if (zoomlvl>0) map.setZoom(zoomlvl);

        }});
        //this.panoramalayer.addTo(this.map);
    }    
    refreshOtherPanoramas(map, markers){     
        var theid=$("#theid").val();
        if (theid>0) {
            var theurl = 'https://places.panotours.gr/wp-json/geo/v1/otherpanoramas/?theid=' + $("#theid").val(); 
            var zoomlvl=10;
        } else {
            var theurl = 'https://places.panotours.gr/wp-json/geo/v1/otherpanoramas'; 
            var zoomlvl=0;
        }
        $.ajax({
            url: theurl, 
            type:'GET',
            data:{filter:$("#theid").val()},
            success:function(response){
                if (this.otherpanoramalayer) {
                    this.mymap.removeLayer(this.otherpanoramalayer);
                    $("#PanoramasZoomButtons").html("");
                };
                this.panoramalayer=L.geoJSON(response, {pointToLayer: function(feature, latlng) {
                    
                    var strButton = "<button id='zoomTo"+feature.properties.id + "'";				
                    strButton += "' class='form-control btn btn-primary attraction'>";
                    strButton += feature.properties.panorama_name+"</button>";
                    $("#PanoramasZoomButtons").append(strButton);
                    
                    $("#zoomTo"+feature.properties.id).click(function(){
                        theid=parseInt(event.currentTarget.id.replace( /^\D+/g, ''));					
                        this.mymap.setView([latlng.lat, latlng.lng], 13);
                        this.panoramalayer.eachLayer(function(layer) {
                            if(layer.options && layer.options.pane === "markerPane") {
                                if (layer.feature.properties.id === theid) {
                                    layer.fire('click');
                                }							
                            }
                        });
                        $("#selected-latdd").text(latlng.lat);
                        $("#selected-londd").text(latlng.lng);
                        // remove the circle from the group layer
                        layerGroup.clearLayers();
                        // add a circle to indicate the focused point 
                        var pointmarker = L.circle([latlng.lat, latlng.lng], {
                            color: '#1a8e9a',
                            fillColor: '#1a8e9a',
                            fillOpacity: 0.4,
                            radius: 135
                        }).addTo(layerGroup);                        
                    });
                    $("#zoomTo"+feature.properties.id).mouseover(function(){					
                        // remove the circle from the group layer
                        layerGroupMouseOver.clearLayers();					
                        var CustomIcon = L.Icon.extend({
                            options: {
                            iconSize:     [28, 28],					   
                            iconAnchor:   [14, 13],					   
                            popupAnchor:  [0, -18]
                            }
                        });
                        var panoramaIcon = new CustomIcon({
                            iconUrl: 'https://places.panotours.gr/wp-content/uploads/2023/07/Icon.png'
                        })										
                        // add a way to indicate the focused point 
                        var mouseoverpointmarker = L.marker([latlng.lat, latlng.lng], {icon: panoramaIcon}).addTo(layerGroupMouseOver);	
                    });				
                    var CustomIcon = L.Icon.extend({
                        options: {
                        iconSize:     [62, 62],					   
                        iconAnchor:   [32, 0],					   
                        popupAnchor:  [-10, -12]
                        }
                    });
                    if (+feature.properties.id==1316) {
                        var panoramaIcon = new CustomIcon({                        
                            iconUrl: 'https://places.panotours.gr/wp-content/uploads/2023/07/Icon.png'
                        })
                    } else {
                        var panoramaIcon = new CustomIcon({                        
                            iconUrl: 'https://places.panotours.gr/wp-content/uploads/2023/07/Icon.png'
                        })
                    }

                    //var strPopup = "<img title='Open in TOTT website' class='open-vtour' src='img/vtour.png' />";
                    var strPopup = "";
                    var thelink = feature.properties.website_url;
                    var tourlink = feature.properties.panorama_link;

                    strPopup += "<h4><a title='Go to website' href='"+thelink+"' target='_parent'>"+feature.properties.title+"</a></h4><hr>";                   
                   var gfg = window.frameElement;
     
                    // Checking if webpage is embedded
                   // if (gfg) {                        
                    if (window.location !== window.parent.location) {
                        // The page is in an iFrame
                        
                        console.log("The page is in an iFrame");
                        strPopup += "<a title='Switch to " + feature.properties.title + " panorama' href='#' onclick=\"parent.postMessage('"+feature.properties.title+"','*');\"'><img src='"+feature.properties.image_path+"' style='width: 260px; box-shadow: #2e2e2e 0px 2px 5px; border: 6px solid white; border-radius: 8px; margin-top: 1px;'></a>";					
                    }
                    else {                        
                        // The page is not in an iFrame
                        console.log("The page is not in an iFrame");
                        strPopup += "<a title='Go to virtual tour " + feature.properties.title + " panorama' target='_blank' href='" + tourlink + "'><img src='"+feature.properties.image_path+"' style='width: 260px; box-shadow: #2e2e2e 0px 2px 5px; border: 6px solid white; border-radius: 8px; margin-top: 1px;'></a>";					
                    }
                    
                    //strPopup += "<a onclick=\"GoToPanorama('"+feature.properties.title+"')\" href='#'><img src='panorama-thumbs/"+feature.properties.image_path+"' style='width: 260px; box-shadow: #2e2e2e 0px 2px 5px; border: 6px solid white; border-radius: 8px; margin-top: 1px;'></a>";                               
                    var PopupClass = {
                        'className': 'panorama-popup'
                    }    
                    return markers.addLayer(L.marker(latlng, {icon: panoramaIcon}).bindPopup(strPopup, PopupClass));
                }});


                markers.addTo(map);
                map.fitBounds(this.panoramalayer.getBounds());
                if (zoomlvl>0) map.setZoom(zoomlvl);

        }});
        //this.panoramalayer.addTo(this.map);
    }
}

export default mainMap;